import { call, all, put, takeEvery } from 'redux-saga/effects';
import {
  getSelfExportFileSuccessAction,
  getSelfExportFileFailureAction,
  getSelfReportSuccessAction,
  getSelfReportFailureAction,
  getSelfDropDownSuccessAction,
  getSelfDropDownFailureAction,
  getEmployeeSuccessAction,
  getEmployeeFailureAction
} from '../../features/Reports/selfAssessmentReportSlice';
import URLs from '../../../constants/urls';
import {
  GET_SELF_REPORT_TABLE_DATA,
  GET_SELF_REPORT_DROP_DOWN,
  GET_SELF_EXPORT_FILE,
  GET_EMPLOYEE
} from '../../actions/Reports/actionSelfTypes';
import { apiPython } from '../../../service/api';
const api = apiPython;
import { getSessionStorage } from '../../../utils/helpers';

export function* getDropDownListSaga() {
  try {
    const userID = getSessionStorage('USER_ID');
    const permissionLevel = getSessionStorage('PERMISSION_LEVEL');
    const response = yield api.get(
      `${URLs.GET_SELF_ASSESSMENT_REPORT}?assessmentcycleID=0&permissionlevel=${permissionLevel}&userSamID=${userID}`
    );
    const data = response.data.data.cycleList;
    

    const response2 = yield api.get(
      `${URLs.GET_SELF_ASSESSMENT_REPORT}?assessmentcycleID=${data[0]?.id}&permissionlevel=${permissionLevel}&userSamID=${userID}`
    );
    yield put(getSelfDropDownSuccessAction(response2.data.data));
  } catch (error) {
    yield put(getSelfDropDownFailureAction(error));
  }
}

export function* getSelfReportListSaga({ payload: data }) {
  try {
    const response = yield api.get(
      `${URLs.GET_SELF_ASSESSMENT_REPORT}?assessmentcycleID=${data['id']}&permissionlevel=${data['permissionlevel']}&userSamID=${data['userSamID']}`
    );
    yield put(getSelfReportSuccessAction(response.data.data));
  } catch (error) {
    yield put(getSelfReportFailureAction(error));
  }
}

export function* getSelfExportFileSaga({ payload: data }) {
  try {
    // let response;
    // if(data['userID']){
    //   const check = 'Self Assessment'
    //   const response = yield api.get(
    //     `${URLs.GET_SELF_EXPORT_FILE}?assessmentcycleID=${data['id']}&userID=${data['userID']}&assessmentCycleName=${check}&permissionlevel=${data['permissionlevel']}&loggedUserID=${getSessionStorage('USER_ID')}`
    //   );
    //   yield put(getSelfExportFileSuccessAction(response.data.data));
    // }else{
    //   const response = yield api.get(
    //     `${URLs.GET_SELF_EXPORT_FILE}?assessmentcycleID=${data['id']}&permissionlevel=${data['permissionlevel']}&loggedUserID=${getSessionStorage('USER_ID')}`
    //   );
    //   yield put(getSelfExportFileSuccessAction(response.data.data));
    // }
    const response = yield api.get(
      `${URLs.GET_SELF_EXPORT_FILE}?assessmentcycleID=${data['id']}&permissionlevel=${
        data['permissionlevel']
      }&loggedUserID=${getSessionStorage('USER_ID')}&assessmentCycleName=${data['assessmentCycleName']}`
    );
    yield put(getSelfExportFileSuccessAction(response.data.data));
  } catch (error) {
    yield put(getSelfExportFileFailureAction(error));
  }
}

export function* getSelfEmployeeSaga({ payload: data }) {
  try {
    const response = yield api.get(
      `${URLs.GET_SELF_ASSESSMENT_REPORT}?assessmentcycleID=${data['assessmentcycleID']}&userID=${data['userID']}&permissionlevel=${data['permissionlevel']}`
    );
    yield put(getEmployeeSuccessAction(response.data.data));
  } catch (error) {
    yield put(getEmployeeFailureAction(error));
  }
}

export function* watchSelfAssessment() {
  yield takeEvery(GET_SELF_REPORT_TABLE_DATA, getSelfReportListSaga);
  yield takeEvery(GET_SELF_REPORT_DROP_DOWN, getDropDownListSaga);
  yield takeEvery(GET_SELF_EXPORT_FILE, getSelfExportFileSaga);
  yield takeEvery(GET_EMPLOYEE, getSelfEmployeeSaga);
}

export default function* selfAssessmentSaga() {
  yield all([watchSelfAssessment()]);
}
